export default "__VITE_ASSET__DpR$RJjc__"